import React from "react";

const Footer = () => {
  return (
    <footer class="content-footer footer bg-footer-theme">
      <div class="container-xxl">
        <div class="footer-container d-flex align-items-center justify-content-between py-4 flex-md-row flex-column">
          <div class="text-body">© OSSANASUR 2025 - {new Date().getFullYear()}</div>
          <div class="d-none d-lg-inline-block">
            <a href="/" class="footer-link me-4">
              Documentation
            </a>

            <a
              href="https://ossansupport.oapps.net/"
              class="footer-link d-none d-sm-inline-block"
            >
              Support
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
